"use client";

import { ErrorView } from "charts/src/components/error-view";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { addMessage, resetChat } from "@/context/redux/reducers/chat-slice";
import { Oriented } from "@/data/constants/oriented";
import { links } from "@/data/links";
import { externalLinks } from "@/data/links/external-links";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

import { useChatStream } from "../../services/chat-stream";

export const RetryErrorView = ({
  query,
  investStyle = null,
  errorMessage,
}: {
  query: string;
  investStyle?: Oriented | null;
  errorMessage?: string;
}) => {
  const router = useRouter();
  const { profile } = useAuth();
  const backendToken = profile?.backendToken;
  const { t, lang } = useLang();
  const dispatch = useAppDispatch();
  const { mutate: sendQuestion } = useChatStream();

  const retry = () => {
    if (!query) return;
    if (!backendToken) {
      router.push(`/${lang}/${links.authLogin}`);
      return;
    }

    dispatch(resetChat());
    dispatch(addMessage({ type: "client", content: query ?? "" }));
    sendQuestion({ query, investStyle });
  };

  return (
    <div>
      <ErrorView errorType="error" className="pl-10">
        {errorMessage ?? t.error.serverError}
      </ErrorView>
      <div className="grid grid-cols-2 gap-9 pl-16">
        <Link href={externalLinks.lineStockmining} target="_blank">
          <Button variant="secondary" className="w-full">
            {t.winwingpt.error.contactUs}
          </Button>
        </Link>
        <Button className="w-full" onClick={retry} disabled={!query}>
          {t.winwingpt.error.retry}
        </Button>
      </div>
    </div>
  );
};
